import { Routes } from '@angular/router';
import { claimResolver } from '@app/resolvers/claim.resolver';
import { dirtyGuard } from '@nittenapps/common';
import { NavItem } from '@nittenapps/components';
import { faCarBurst, faChartLine, faPhoneOffice, faUserCheck } from '@fortawesome/pro-duotone-svg-icons';

export const CALL_CENTER_ITEMS: NavItem[] = [
  {
    label: 'Cabina',
    icon: faPhoneOffice,
    iconSet: 'duo',
    roles: ['call_center_phone', 'call_center_radio', 'call_center_tourist', 'call_center_mngr'],
    children: [
      {
        label: 'Tablero',
        icon: faChartLine,
        iconSet: 'duo',
        roles: ['call_center_mngr'],
        routerLink: ['call-center', ''],
        hidden: true,
      },
      {
        label: 'Registrar Siniestro',
        icon: faCarBurst,
        iconSet: 'duo',
        roles: ['call_center_phone', 'call_center_mngr'],
        routerLink: ['call-center', 'create-claim'],
      },
      {
        label: 'Registrar Siniestro Turistas',
        icon: faCarBurst,
        iconSet: 'duo',
        roles: ['call_center_tourist'],
        routerLink: ['call-center', 'create-claim-tourist'],
      },
      {
        label: 'Asignar Ajustador',
        icon: faUserCheck,
        iconSet: 'duo',
        roles: ['call_center_radio', 'call_center_mngr'],
        routerLink: ['call-center', 'assign-adjuster'],
      },
      {
        label: 'Asignar Ajustador Turistas',
        icon: faUserCheck,
        iconSet: 'duo',
        roles: ['call_center_tourist'],
        routerLink: ['call-center', 'assign-adjuster-tourist'],
      },
    ],
  },
];

export const ROUTES: Routes = [
  {
    path: 'assign-adjuster',
    loadComponent: () => import('@nittenapps/activity').then((m) => m.ActivityComponent),
    data: {
      breadcrumb: 'Asignar Ajustador',
      roles: ['call_center_radio', 'call_center_mngr'],
    },
    children: [
      {
        path: '',
        loadComponent: () => import('./assign-adjuster/list/list.component').then((m) => m.ListComponent),
      },
      {
        path: ':id',
        loadComponent: () => import('./assign-adjuster/detail/detail.component').then((m) => m.DetailComponent),
        canDeactivate: [dirtyGuard],
        resolve: { model: claimResolver },
        data: {
          breadcrumb: { disabled: true, label: (data: any) => `${data.model.extNumber || data.model.number}` },
        },
      },
    ],
  },
  {
    path: 'assign-adjuster-tourist',
    loadComponent: () => import('@nittenapps/activity').then((m) => m.ActivityComponent),
    data: {
      breadcrumb: 'Asignar Ajustador Turistas',
      roles: ['call_center_tourist'],
    },
    children: [
      {
        path: '',
        loadComponent: () => import('./assign-adjuster-tourist/list/list.component').then((m) => m.ListComponent),
      },
      {
        path: ':id',
        loadComponent: () => import('./assign-adjuster-tourist/detail/detail.component').then((m) => m.DetailComponent),
        canDeactivate: [dirtyGuard],
        resolve: { model: claimResolver },
        data: {
          breadcrumb: { disabled: true, label: (data: any) => `${data.model.extNumber || data.model.number}` },
        },
      },
    ],
  },
  {
    path: 'create-claim',
    loadComponent: () => import('@nittenapps/activity').then((m) => m.ActivityComponent),
    data: {
      breadcrumb: 'Registrar Siniestro',
      roles: ['call_center_phone', 'call_center_mngr'],
    },
    children: [
      {
        path: '',
        loadComponent: () => import('./create-claim/list/list.component').then((m) => m.ListComponent),
      },
      {
        path: ':id',
        loadComponent: () => import('./create-claim/detail/detail.component').then((m) => m.DetailComponent),
        canDeactivate: [dirtyGuard],
        resolve: { model: claimResolver },
        data: {
          breadcrumb: {
            disabled: true,
            label: (data: any) => `${data.model.extNumber || data.model.number || 'Nuevo'}`,
          },
        },
      },
    ],
  },
  {
    path: 'create-claim-tourist',
    loadComponent: () => import('@nittenapps/activity').then((m) => m.ActivityComponent),
    data: {
      breadcrumb: 'Registrar Siniestro Turistas',
      roles: ['call_center_tourist'],
    },
    children: [
      {
        path: '',
        loadComponent: () => import('./create-claim-tourist/list/list.component').then((m) => m.ListComponent),
      },
      {
        path: ':id',
        loadComponent: () => import('./create-claim-tourist/detail/detail.component').then((m) => m.DetailComponent),
        canDeactivate: [dirtyGuard],
        resolve: { model: claimResolver },
        data: {
          breadcrumb: {
            disabled: true,
            label: (data: any) => `${data.model.extNumber || data.model.number || 'Nuevo'}`,
          },
        },
      },
    ],
  },
];
